import React, { useState, useEffect } from 'react'
import './SportMarketTabs.scss'
import SportMarketStandardFancy from '../../components/SportMarketStandardFancy/SportMarketStandard'
import { useDispatch, useSelector } from 'react-redux'
import { requestBetPlacingStartAll } from '../../store/betPlacing/betPlacing.thunks'

const SportMarketTabs = ({
  data,
  betPlacing,
  elementsParams,
  categories,
  activeTab,
  setActiveTab,
  inplay
}) => {
  const checkStateWidth = useSelector(
    (state) => state.elementsParams.clientWidth
  )
  const width = checkStateWidth ? checkStateWidth : window.innerWidth;



  const shorData = [
    'Session Markets',
    'Over by Over',
    'Ball by Ball',
    'Fall Of Wicket',
    'NORMAL',
    'Total Advance',
    'Khado',
    'Meter',
    'oddeven',
    'Fancy1',
  ]

  // Filter categories to only include those with data
  const filteredCategoryKeys = categories
    ? Object.keys(categories).filter((key) =>
        data?.some((item) => item.category === Number(key))
      )
    : []

  const sortedCategoryKeys = filteredCategoryKeys.sort((a, b) => {
    const nameA = categories[a]?.trim()
    const nameB = categories[b]?.trim()
    const indexA = shorData.findIndex(
      (item) => item.toLowerCase() === nameA.toLowerCase()
    )
    const indexB = shorData.findIndex(
      (item) => item.toLowerCase() === nameB.toLowerCase()
    )

    if (indexA === -1 && indexB === -1) return 0
    if (indexA === -1) return 1
    if (indexB === -1) return -1
    return indexA - indexB
  })

  return (
    <section className="SportMarketTabs">
      <div
        className="SportMarketTabs__header"
        style={{
          overflow: 'scroll',
        }}
      >
        {/* Only show 'All' if there is data */}
        {data?.length > 0 && (
          <div
            key={'all'}
            className={`SportMarketTabs__header__item ${
              'All' == activeTab ? 'active' : ''
            }`}
            onClick={() => setActiveTab('All')}
          >
            All
          </div>
        )}

        {categories &&
          sortedCategoryKeys.map((tabGroupIndex, index) => (
            <div
              key={tabGroupIndex ?? index} // fallback to index if key missing
              className={`SportMarketTabs__header__item ${
                tabGroupIndex == activeTab ? 'active' : ''
              }`}
              style={{
                whiteSpace: 'nowrap',
              }}
              onClick={() => setActiveTab(tabGroupIndex)}
            >
              {categories[tabGroupIndex]}
            </div>
          ))}
      </div>

      <div className="SportMarketTabs__markets">
        {width > 1024 && (
          <div className="SportMarketTabs__markets_fancy-title">
            <div>Session Runs</div>
            <div className="SportMarketTabs__markets_fancy-title-block">
              {Number(activeTab) !== 5 ||
                (Number(activeTab) !== 6 && <span>No</span>)}
              {Number(activeTab) !== 5 ||
                (Number(activeTab) !== 6 && <span>Yes</span>)}
            </div>
          </div>
        )}

        {activeTab &&
          data?.length > 0 &&
          data
            ?.filter(
              (item) =>
                activeTab === 'All' || item.category === Number(activeTab)
            )
            .map((item, index) => (
              <div
                key={item.id ?? index}
                className="SportMarketTabs__markets__item"
              >
                <SportMarketStandardFancy
                  data={item}
                  betPlacing={betPlacing}
                  fancy={true}
                  activeTab={activeTab}
                  inplay={inplay}
                />
              </div>
            ))}
      </div>
    </section>
  )
}

export default SportMarketTabs
